import {gql} from '@apollo/client';

export const FEE_PROFILE_FRAGMENT = gql`
  fragment FeeProfileFragment on FeeProfileType {
    id
    name
    amount
  }
`;
